// extracted by css-extract-rspack-plugin
export default {"partTitle":"_OCJVk","subLabel":"U6CeI0","part":"XDTr7X","label":"AvlXbw"};